import React, { Component, useRef, useEffect, useState, createContext } from 'react';

// import { chromeDetect } from 'find-chrome-version';
// import { Orientation } from '../components/Orientation';
import { isMobile } from "react-device-detect";


import { useTranslation } from 'react-i18next';
import '../99_untils/i18n';

import {
  Button, Container, Row, Col,
  // Card, CardBody, CardTitle, CardSubtitle, CardText 
} from 'reactstrap';

// import { TweenMax, Sine, Bounce, Power2 } from 'gsap';
import gsap from "gsap";

import apiURLs from '../99_untils/apiURLs';
// import SEOHelmet from '../99_untils/SEOHelmet';

// Import the initialized services from your config file
import { auth, db } from '../99_untils/firebase/';
import {
  signInWithCustomToken
} from "firebase/auth";
// import UserAuthContext from "../99_untils/firebase/UserAuthContext";

import LoadingIndicator from "../99_untils/LoadingIndicator";
import { openUrl } from '../99_untils/flutterCallback';

// import AppNavi from "../Navigation/NavigationHome";
import AppNavi from "../Navigation/NavigationBlink";
import Footer from "../Footer/Footer";

import AppNaviDesktop from "../Navigation/NavigationDesktop";
import FooterDesktop from "../Footer/FooterDesktop";



import './Home.css';
import DutyCheckContext from "./DutyCheckContext";


// import QRCodeImg from './images/QR-code-twice-mini-site.jpeg';
// import QRCodeImg from './images/QR-code-blink-mini-site.jpg';
import QRCodeImg from './images/QR-code-blink-mini-site2.jpg';
import imgBadgeApple from './images/app-store-badges-apple3.png';
import imgBadgeGoogle from './images/app-store-badges-google3.png';

import LiveMappingSection from '../01_LiveMapping/LiveMapping';
import HomeBannerSection from '../01_HomeBanner/HomeBanner';
import MiniGameSection from '../02_minigame/MiniGameLanding';
import IGPostsSection from '../03_IGPosts/IGPosts';


// export class Home extends Component {
export default function Home() {

  const isMountedRef = useRef(false);
  const gaLoadRef = useRef();

  const { t } = useTranslation();
  const { i18n } = useTranslation();
  let curLang = i18n.language;

  const fakeLoadMaskRef = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadAniFinished, setLoadAniFinished] = useState(false);
  
  // Auth state
  const [authToken, setAuthToken] = useState(null);
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const [authError, setAuthError] = useState(null);
  const authTimeoutRef = useRef(null);
  
  // Configurable timeout in milliseconds (default 3 seconds)
  const AUTH_TIMEOUT = 3000;

  // const [isMobileView, setIsMobileView] = useState(false);

  const isMobileView = useRef(true);
  const isMobileViewBadges = useRef(true);

  let fanClubWordings = null;

  const [animationWordsArray, setAnimationWordsArray] = useState([]);
  const [animationDuration, setAnimationDuration] = useState(3000);


  const passAuthTempRef = useRef(true);
  const userAuthRef = useRef(null);
  const authEventHandlerRef = useRef(null);

  /**
   * Validates the auth token by calling the leaderboard API
   * @param {string} token - The auth token to validate
   * @returns {Promise<boolean>} - Returns true if validation succeeds
   */
  const validateAuthToken = async (token) => {
    console.log('Home validateAuthToken called with token:', token ? 'present' : 'missing');
    
    try {
      const response = await fetch(apiURLs.getLeaderboardDataURL, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('Home validateAuthToken response status:', response.status);
      
      // Check if response is successful (2xx status codes)
      if (response.ok) {
        console.log('Home validateAuthToken - Auth token validated successfully');
        return true;
      } else {
        console.error('Home validateAuthToken - API returned error status:', response.status);
        return false;
      }
    } catch (error) {
      console.error('Home validateAuthToken - Error validating token:', error);
      return false;
    }
  };

  /**
   * Handles the authentication flow
   * Waits for token from mobile app and validates it
   */
  const handleAuthentication = async () => {
    console.log('Home handleAuthentication started');
    
    // Listen for auth token from mobile app webview
    const handleAuthTokenEvent = async (event) => {
      console.log('Home handleAuthTokenEvent - Token received from mobile app');
      console.log('Home handleAuthTokenEvent - event.detail.token');
      console.log(event.detail.token);

      const token = event.detail.token;
      
      if (authTimeoutRef.current) {
        clearTimeout(authTimeoutRef.current);
        authTimeoutRef.current = null;
      }
      
      setAuthToken(token);
      
      // Validate token by calling leaderboard API
      const isValid = await validateAuthToken(token);
      
      if (isValid) {
        console.log('Home handleAuthTokenEvent - Token is valid, showing page');
        userAuthRef.current = { token: token, validated: true };
        setIsAuthChecked(true);
        setAuthError(null);
        
        // Remove loading mask
        setTimeout(() => {
          fakeLoadMaskOut();
        }, animationDuration);
      } else {
        console.error('Home handleAuthTokenEvent - Token validation failed');
        setAuthError('validation_failed');
        setIsAuthChecked(true);
        userAuthRef.current = null;
        
        // Show error message
        setTimeout(() => {
          fakeLoadMaskOut();
        }, animationDuration);
      }
    };
    
    // Store handler reference for cleanup
    authEventHandlerRef.current = handleAuthTokenEvent;
    

    console.log('Home handleAuthentication window.addEventListener authTokenReceived');
    // Add event listener for token from mobile app
    window.addEventListener('authTokenReceived', handleAuthTokenEvent);
    
    // Check if token was already received before component mounted
    if (window.authTokenReceived && window.authTokenData) {
    // if (window.authTokenData) {
      console.log('Home handleAuthentication - Token already present, using it');
      handleAuthTokenEvent({ detail: { token: window.authTokenData } });
      return;
    }
    
    // Set timeout - if no token received within AUTH_TIMEOUT, show error
    authTimeoutRef.current = setTimeout(() => {
      console.log('Home handleAuthentication - Timeout waiting for auth token');
      setAuthError('timeout');
      setIsAuthChecked(true);
      userAuthRef.current = null;
      
      // Show error message
      setTimeout(() => {
        fakeLoadMaskOut();
      }, animationDuration);
    }, AUTH_TIMEOUT);
    
    console.log(`Home handleAuthentication - Waiting for token (timeout: ${AUTH_TIMEOUT}ms)`);
  };



  const dutyOnStatusRef = useRef(false);
  // let dutyCheckInterval = null;

  // Function to get current Hong Kong local time
  const getCurrentHKTime = () => {
    const now = new Date();
    // Convert to Hong Kong timezone (UTC+8)
    const hkTime = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Hong_Kong" }));
    return hkTime;
  };


  const handleLoading = () => {
    setIsLoading(false);
    // console.log("Home setIsLoading(false)")
  }

  const fakeLoadMaskOut = () => {

    console.log('Home fakeLoadMaskOut is called');
    // if (userAuthRef.current) {
    if (fakeLoadMaskRef.current) {
      // GSAP fade out animation
      gsap.to(fakeLoadMaskRef.current, {
        opacity: 0,
        duration: 0.5,
        ease: "power2.out",
        onComplete: () => {
          setLoadAniFinished(true);
          console.log('Home fakeLoadMaskOut is true');
        }
      });
    }
    // } else {
    //   console.log('userAuthRef.current is null');
    // }

    // if (fakeLoadMaskRef.current) {
    //   // GSAP fade out animation
    //   gsap.to(fakeLoadMaskRef.current, {
    //     opacity: 0,
    //     duration: 0.5,
    //     ease: "power2.out",
    //     onComplete: () => {
    //       setLoadAniFinished(true);
    //     }
    //   });
    // } else {
    //   // console.log('fakeLoadMaskRef.current is null');
    // }

    // clearInterval(intervalIdfakeLoad);
  }


  useEffect(() => {
    isMountedRef.current = true;

    if (!gaLoadRef.current) {

      gaLoadRef.current = true;

      if (window.gtag) {
        window.gtag('event', 'view_home_page', {
          page_section: 'campaign_microsite'
        });
        // console.log("Home gtag page_view sent");
      }


    }



    // Handle both initial load and revisits
    const handlePageReady = () => {
      // Check if document is already loaded (for revisits)
      if (document.readyState === 'complete') {
        setIsLoading(false);
        // console.log("Home addEventListener load complete")
      } else {
        // For initial loads, wait for load event
        window.addEventListener("load", handleLoading);
        // console.log("Home addEventListener load")
      }
    };

    const fetchData = async () => {
      try {

        //process.env.NODE_ENV
        const response = await fetch(apiURLs.getLiveMapDataURL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...(window.authTokenData ? { 'Authorization': `Bearer ${window.authTokenData}` } : {})
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();

        // console.log('Home fetchData result:', result.heartbeats);

        if (Object.values(result.heartbeats).length === 0) {
          // console.log('Home fetchData result.heartbeats.length:??', Object.values(result.heartbeats).length);
          dutyOnStatusRef.current = false;
        } else {
          // console.log('Home fetchData duty on result.heartbeats.length:', Object.values(result.heartbeats).length);
          dutyOnStatusRef.current = true;
        }

        // dutyOnStatusRef.current = false;
        // dutyOnStatusRef.current = true;
        // console.log('Home result.heartbeats.length = ', result.heartbeats.length);



      } catch (error) {
        // console.error('Home fetchData error:', error);
        // setErrorFound(error);
      } finally {
        // setDataLoading(false);
      }
    };

    handlePageReady();
    fetchData();
    const intervalCheckDuty = setInterval(fetchData, 3000);

    // Start authentication flow
    handleAuthentication();

    // console.log("Home useEffect mounted");

    return () => {
      isMountedRef.current = false;
      if (intervalCheckDuty) clearInterval(intervalCheckDuty);
      if (authTimeoutRef.current) clearTimeout(authTimeoutRef.current);
      window.removeEventListener("load", handleLoading);
      if (authEventHandlerRef.current) {
        window.removeEventListener('authTokenReceived', authEventHandlerRef.current);
      }
    };
  }, []);


  return (
    // return !isLoading && isLoadAniFinished ? (
    <>
      {/* <SEOHelmet 
        titleKey="metaTitleHome" 
        descriptionKey="metaDescriptionHome" 
        canonicalPath={`/${curLang}`}
      /> */}
      {/* {isMobile ? ( */}
      {/* {
        <div ref={fakeLoadMaskRef} className={`${isLoadAniFinished ?
          'home-loading-wrap display-none' : 'home-loading-wrap'}`}>
          <LoadingIndicator quoteContent={t('homeLoadAniText')} fanClubContent={t('homeLoadAniByText')} />
        </div >
      } */}
      {
        <div ref={fakeLoadMaskRef} className={`${isLoadAniFinished ?
          'home-loading-wrap display-none' : 'home-loading-wrap'}`}>
          <LoadingIndicator quoteContent={t('homeLoadAniText')} fanClubContent={t('homeLoadAniByText')} />
        </div >
      }
      {/* <UserAuthContext.Provider value={userAuthRef.current}> */}
        {
          // Show main content only if auth is successful
          // passAuthTempRef.current ?
          userAuthRef.current && isAuthChecked && !authError ?
            (

                <div className="HomeWrap">
                  <DutyCheckContext.Provider value={dutyOnStatusRef.current}>
                    <AppNavi />
                    <div className='canvas-container home'>

                      {/* { userAuthRef.current &&
                        <div className='home-section-wrap map'>
                          <div>
                            <h6>For dev use</h6>
                            <h6>userAuthRef.current = {userAuthRef.current}</h6>
                            <h6>userAuthRef.current.token = {userAuthRef.current.token}</h6>
                          </div>
                        </div>
                      } */}

                      <div className='home-section-wrap map'>
                        <LiveMappingSection />
                      </div>
                      <div className='home-section-wrap activity'>
                        <HomeBannerSection />
                      </div>
                      <div className='home-section-carousel-taxis-wrap'>
                        <div className='home-section-carousel-taxis'></div>
                      </div>
                      <div className='home-section-wrap minigame'>
                        <MiniGameSection />
                      </div>
                      <div className='home-section-wrap igposts'>
                        <IGPostsSection />
                      </div>
                    </div>
                    <Footer />
                  </DutyCheckContext.Provider>
                </div>

            ) : (


              <div className='home-secton-mask-desktop'>
                <AppNaviDesktop />
                <Container>
                  <Row className=''>
                    <Col className="" md={{ offset: 3, size: 6 }} >

                      <h5 className='text-uppercase color-text-pink margin-bot-10'>
                        {t('HomeDesktopSorryTitle')}
                      </h5>
                      {
                        isMobile ?
                          <p className='color-text-pink margin-bot-30'>
                            {t('HomeDesktopSorryInstructionMobile')}
                          </p> :
                          <p className='color-text-pink margin-bot-30'>
                            {t('HomeDesktopSorryInstruction')}
                          </p>
                      }
                      {/* Show auth error if present, otherwise show default desktop message */}
                      {/* {isAuthChecked && authError ? (
                        <>
                          <h5 className='text-uppercase color-text-pink margin-bot-10'>
                            {t('HomeAuthErrorTitle')}
                          </h5>
                          <p className='color-text-pink margin-bot-30'>
                            {t('HomeAuthErrorMessage')}
                          </p>
                        </>
                      ) : (
                        <>
                          <h5 className='text-uppercase color-text-pink margin-bot-10'>
                            {t('HomeDesktopSorryTitle')}
                          </h5>
                          {
                            isMobile ?
                              <p className='color-text-pink margin-bot-30'>
                                {t('HomeDesktopSorryInstructionMobile')}
                              </p> :
                              <p className='color-text-pink margin-bot-30'>
                                {t('HomeDesktopSorryInstruction')}
                              </p>
                          }
                        </>
                      )} */}

                      {/* Only show app store badges/QR code if no auth error */}
                      {
                        isMobile ?
                          (<div className='home-section-mask-mobile-appstorebadges'>
                            <Button color='link' className='w-100' title='Play game' onClick={() => {
                              openUrl("https://l.d-ash.com/khedc", "https://l.d-ash.com/khedc");
                            }}>
                              <img className="img-full-width" src={imgBadgeApple} alt="" />
                            </Button>
                            <Button color='link' className='w-100' title='Play game' onClick={() => {
                              openUrl("https://l.d-ash.com/khedc", "https://l.d-ash.com/khedc");
                            }}>
                              <img className="img-full-width" src={imgBadgeGoogle} alt="" />
                            </Button>
                          </div>
                          )
                          : (
                            <Container>
                              <Row className=''>
                                <Col className="" md={{ offset: 2, size: 8 }} >
                                  <div>
                                    <h6 className='text-uppercase color-text-pink home-section-mask-desktop-scan-here-subtitle'>
                                      {t('HomeDesktopSorryScanHereSubtitle')}
                                    </h6>
                                    <div className='home-section-mask-desktop-qrcode'>
                                      <img className='img-full-width' src={QRCodeImg} alt="QR Code to visit this site on mobile" />
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </Container>
                          )}
                      {/* {(!isAuthChecked || !authError) && (
                        <>
                          {
                            isMobile ?
                              (<div className='home-section-mask-mobile-appstorebadges'>
                                <Button color='link' className='w-100' title='Play game' onClick={() => {
                                  openUrl("https://l.d-ash.com/d7m2v", "https://l.d-ash.com/d7m2v");
                                }}>
                                  <img className="img-full-width" src={imgBadgeApple} alt="" />
                                </Button>
                                <Button color='link' className='w-100' title='Play game' onClick={() => {
                                  openUrl("https://play.google.com/store/apps/details?id=com.dashapp.user&hl=en", "https://play.google.com/store/apps/details?id=com.dashapp.user&hl=en");
                                }}>
                                  <img className="img-full-width" src={imgBadgeGoogle} alt="" />
                                </Button>
                              </div>
                              )
                              : (
                                <Container>
                                  <Row className=''>
                                    <Col className="" md={{ offset: 2, size: 8 }} >
                                      <div>
                                        <h6 className='text-uppercase color-text-pink home-section-mask-desktop-scan-here-subtitle'>
                                          {t('HomeDesktopSorryScanHereSubtitle')}
                                        </h6>
                                        <div className='home-section-mask-desktop-qrcode'>
                                          <img className='img-full-width' src={QRCodeImg} alt="QR Code to visit this site on mobile" />
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Container>
                              )}
                        </>
                      )} */}
                    </Col>
                  </Row>
                </Container>
                <FooterDesktop />
              </div>

            )}
      {/* </UserAuthContext.Provider> */}
    </>
  )
}

